export default "__VITE_ASSET__BYGhdgD8__"